import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 内部種類 */
enum InternalCategory {
  buildings = '10',
  buildingAccessories = '11',
  structure = '12',
  machineryAndEquip = '13',
  marineVessels = '14',
  aircraft = '15',
  vehicleTransportEquip = '16',
  toolFixtureFurnishings = '17',
  land = '18',
  cp = '19',
  goodwill = '20',
  patent = '21',
  leasehold = '22',
  superficies = '23',
  trademarkRights = '24',
  utilityModelRights = '25',
  designRights = '26',
  miningRights = '27',
  fishingRights = '28',
  waterRights = '29',
  phoneSubscriptionPermission = '30',
  facilityUsageRights = '31',
  software = '32',
  otherIntangible = '33',
  livestock = '40',
  fruitTree = '41',
  otherTrees = '42',
  longTermPrePaidExpense = '50',
  initialExpenses = '51',
  openingExpense = '52',
  newStockIssueExpense = '53',
  costBondIssue = '54',
  premiumBond = '55',
  developmentExpense = '56',
  testResearchExpenses = '57',
}

const nameConfig = {
  buildings: new Map([
    [Locale.ja, '建物'],
    [Locale.en, 'Buildings'],
  ]),
  buildingAccessories: new Map([
    [Locale.ja, '建物付属設備'],
    [Locale.en, 'Building Accessories'],
  ]),
  structure: new Map([
    [Locale.ja, '構築物'],
    [Locale.en, 'Structure'],
  ]),
  machineryAndEquip: new Map([
    [Locale.ja, '機械・装置'],
    [Locale.en, 'Machinery・Equip'],
  ]),
  marineVessels: new Map([
    [Locale.ja, '船舶'],
    [Locale.en, 'MarineVessels'],
  ]),
  aircraft: new Map([
    [Locale.ja, '航空機'],
    [Locale.en, 'Aircraft'],
  ]),
  vehicleTransportEquip: new Map([
    [Locale.ja, '車両・運搬具'],
    [Locale.en, 'Vehicle・Transport Equip'],
  ]),
  toolFixtureFurnishings: new Map([
    [Locale.ja, '工具・器具・備品'],
    [Locale.en, 'Tool・Fixture・Furnishings'],
  ]),
  land: new Map([
    [Locale.ja, '土地'],
    [Locale.en, 'Land'],
  ]),
  cp: new Map([
    [Locale.ja, '建設仮勘定'],
    [Locale.en, 'CP'],
  ]),
  goodwill: new Map([
    [Locale.ja, '営業権'],
    [Locale.en, 'Goodwill'],
  ]),
  patent: new Map([
    [Locale.ja, '特許権'],
    [Locale.en, 'Patent'],
  ]),
  leasehold: new Map([
    [Locale.ja, '借地権'],
    [Locale.en, 'Leasehold'],
  ]),
  superficies: new Map([
    [Locale.ja, '地上権'],
    [Locale.en, 'Superficies'],
  ]),
  trademarkRights: new Map([
    [Locale.ja, '商標権'],
    [Locale.en, 'Trademark Rights'],
  ]),
  utilityModelRights: new Map([
    [Locale.ja, '実用新案権'],
    [Locale.en, 'Utility ModelRights'],
  ]),
  designRights: new Map([
    [Locale.ja, '意匠権'],
    [Locale.en, 'Design Rights'],
  ]),
  miningRights: new Map([
    [Locale.ja, '鉱業権'],
    [Locale.en, 'Mining Rights'],
  ]),
  fishingRights: new Map([
    [Locale.ja, '漁業権'],
    [Locale.en, 'Fishing Rights'],
  ]),
  waterRights: new Map([
    [Locale.ja, '水利権'],
    [Locale.en, 'Water Rights'],
  ]),
  phoneSubscriptionPermission: new Map([
    [Locale.ja, '電話加入権'],
    [Locale.en, 'Phone Subscription Permission'],
  ]),
  facilityUsageRights: new Map([
    [Locale.ja, '施設利用権'],
    [Locale.en, 'Facility Usage Rights'],
  ]),
  software: new Map([
    [Locale.ja, 'ソフトウェア'],
    [Locale.en, 'Software'],
  ]),
  otherIntangible: new Map([
    [Locale.ja, 'その他無形'],
    [Locale.en, 'Other Intangible'],
  ]),
  livestock: new Map([
    [Locale.ja, '家畜'],
    [Locale.en, 'Livestock'],
  ]),
  fruitTree: new Map([
    [Locale.ja, '果樹'],
    [Locale.en, 'Fruit Tree'],
  ]),
  otherTrees: new Map([
    [Locale.ja, 'その他樹木'],
    [Locale.en, 'Other Trees'],
  ]),
  longTermPrePaidExpense: new Map([
    [Locale.ja, '長期前払費用'],
    [Locale.en, 'Long Term Pre Paid Expense'],
  ]),
  initialExpenses: new Map([
    [Locale.ja, '創業費'],
    [Locale.en, 'Initial Expenses'],
  ]),
  openingExpense: new Map([
    [Locale.ja, '開業費'],
    [Locale.en, 'Opening Expense'],
  ]),
  newStockIssueExpense: new Map([
    [Locale.ja, '新株発行費'],
    [Locale.en, 'New Stock Issue Expense'],
  ]),
  costBondIssue: new Map([
    [Locale.ja, '社債発行費'],
    [Locale.en, 'Cost Bond Issue'],
  ]),
  premiumBond: new Map([
    [Locale.ja, '社債発行差金'],
    [Locale.en, 'Premium Bond'],
  ]),
  developmentExpense: new Map([
    [Locale.ja, '開発費'],
    [Locale.en, 'Development Expense'],
  ]),
  testResearchExpenses: new Map([
    [Locale.ja, '試験研究費'],
    [Locale.en, 'Test Research Expenses'],
  ]),
};

const toEnum = rawValueToEnum(InternalCategory, InternalCategory.buildings);
const toDisplay = enumToName(InternalCategory, nameConfig);
const toDisplayWithPrefix = enumToName(InternalCategory, nameConfig, { prefix: true });

export const internalCategory = {
  enum: InternalCategory,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { InternalCategory };
